/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Auto_Format_DoneInputs */

const en_context_menu_auto_format_done = /** @type {(inputs: Context_Menu_Auto_Format_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto format completed`)
};

const fr_context_menu_auto_format_done = /** @type {(inputs: Context_Menu_Auto_Format_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en forme automatique terminée`)
};

const de_context_menu_auto_format_done = /** @type {(inputs: Context_Menu_Auto_Format_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Formatierung abgeschlossen`)
};

const it_context_menu_auto_format_done = /** @type {(inputs: Context_Menu_Auto_Format_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formattazione automatica completata`)
};

const ru_context_menu_auto_format_done = /** @type {(inputs: Context_Menu_Auto_Format_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое форматирование завершено`)
};

const es_context_menu_auto_format_done = /** @type {(inputs: Context_Menu_Auto_Format_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato automático completado`)
};

const zh_cn2_context_menu_auto_format_done = /** @type {(inputs: Context_Menu_Auto_Format_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动格式化完成`)
};

const ja_context_menu_auto_format_done = /** @type {(inputs: Context_Menu_Auto_Format_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動フォーマットが完了しました`)
};

const hi_context_menu_auto_format_done = /** @type {(inputs: Context_Menu_Auto_Format_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो फॉर्मेट पूरा हुआ`)
};

const pt_pt2_context_menu_auto_format_done = /** @type {(inputs: Context_Menu_Auto_Format_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação automática concluída`)
};

/**
* | output |
* | --- |
* | "Auto format completed" |
*
* @param {Context_Menu_Auto_Format_DoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_auto_format_done = /** @type {((inputs?: Context_Menu_Auto_Format_DoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Auto_Format_DoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_auto_format_done(inputs)
	if (locale === "de") return de_context_menu_auto_format_done(inputs)
	if (locale === "it") return it_context_menu_auto_format_done(inputs)
	if (locale === "ru") return ru_context_menu_auto_format_done(inputs)
	if (locale === "es") return es_context_menu_auto_format_done(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_auto_format_done(inputs)
	if (locale === "ja") return ja_context_menu_auto_format_done(inputs)
	if (locale === "hi") return hi_context_menu_auto_format_done(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_auto_format_done(inputs)
	return en_context_menu_auto_format_done(inputs)
});